import React from 'react';
import HomeIconExit from 'components/HomeExitIcon';
import PageTitleBar from 'components/PageTitleBar';
import PromoPerksIcon from 'resources/FeatureIcons/Button-PromoPerks.svg';
import './PageOverlay.css';

function PageOverlay({ children, title, closeUrl = '/', withExit }) {
  return (
    <div className="page-overlay-wrapper">
      <div className="page-overlay-container">
        {title && <PageTitleBar title={title} icon={PromoPerksIcon} />}
        {children}
        {withExit && <HomeIconExit url={closeUrl} />}
      </div>
    </div>
  );
}

export default PageOverlay;
